import React, {useEffect} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Header from './components/Header';
import About from './pages/About';
import ContactPage from "./pages/ContactPage";
import Home from './pages/Home';
import Services from './pages/Services';
import './App.scss';
import ScrollToTop from "./components/ScrollToTop.js"

function App() {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.replace("#", ""));
            if (element) {
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                element.scrollIntoView({behavior: reduceMotion ? "auto" : "smooth", block: "start"});
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    return (
        <div className="App">
            <a className="skip-link visually-hidden-focusable" href="#main-content"
               onClick={event => {
                   event.preventDefault();
                   document.getElementById('main-content')?.focus();
               }}>
                Skip to main content
            </a>
            <Header/>
            <main id="main-content" className="app-container" tabIndex={-1}>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/home" element={<Home/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="/services" element={<Services/>}/>
                    <Route path="/contact" element={<ContactPage/>}/>
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>
            </main>
            <ScrollToTop/>
        </div>
    );
}

function AppWithRouter() {
    return (
        <Router future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
            <App/>
        </Router>
    );
}

export default AppWithRouter;
